import 'scss/services/lfasr.scss'
import 'babel-polyfill'
import {
  serviceQA,
  serviceTopbar
} from 'js/libs/utils-services'
import {
  init as initServiceOpen,
  showserviceOpenModal
} from 'js/libs/utils-services-open'
import { config } from 'config'
import { goServiceBuy } from 'js/libs/utils-services-buy'
import { getQueryString } from 'js/libs/utils'

initServiceOpen()

$(function () {
  $('.answer-table .buy-btn').click(function () {
    let packageId = $(this).attr('package-id')
    let params = {
      wareId: '1006',
      packageId: packageId,
      serviceName: '语音转写',
      businessId: 'lfasr'
    }
    goServiceBuy(params)
  })
  $('.answer-table .get-btn').click(function () {
    showserviceOpenModal({
      urlParams: {
        'type': 'service',
        'businessName': '语音转写',
        'dialog': 'apply'
      }
    }, {
      detailUrl: `${config.CONSOLE}services/lfasr`,
      appIdKey: 'appId',
      needAppOs: true,
      needBusinessId: true
    })
  })
  serviceQA()
  serviceTopbar()
})



// WEBPACK FOOTER //
// ./src/js/entry/services/lfasr.js